import PanelPosition from "./PanelPosition"

export default  PanelPosition;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/PanelPosition/index.js